import { cx } from '../../lib/cx';
import { Icon, type IconName } from '../Icon';

import styles from './BottomTabBar.module.css';

export interface TabItem {
  id: string;
  label: string;
  icon: IconName;
  href?: string;
}

export interface BottomTabBarProps {
  /** Three to five sections: more do not fit a phone. */
  items: readonly TabItem[];
  activeId: string;
  onSelect?: (id: string) => void;
  /** Name of the navigation landmark. */
  label?: string;
  className?: string;
}

/** The navigation of a phone: the sections under the thumb, each a 48 px target. */
export function BottomTabBar({ items, activeId, onSelect, label = 'Sections', className }: BottomTabBarProps) {
  return (
    <nav aria-label={label} className={cx(styles.bar, className)}>
      {items.map((item) => (
        <a
          key={item.id}
          href={item.href ?? `#${item.id}`}
          aria-current={item.id === activeId ? 'page' : undefined}
          className={styles.tab}
          onClick={(event) => {
            if (!onSelect) return;
            event.preventDefault();
            onSelect(item.id);
          }}
        >
          <Icon name={item.icon} size={22} />
          <span>{item.label}</span>
        </a>
      ))}
    </nav>
  );
}
